import React from "react";
import { ReactComponent as CoffeeTableSvg } from "../svg/coffee-table.svg";

export default function CoffeeTableIcon({ size = 64, color = "#32363F", ...props }) {
  return <CoffeeTableSvg width={size} height={size} style={{ color }} {...props} />;
}
